module.exports = __webpack_public_path__ + "img/W-S59.4a9c3b59.jpg";